<template>
  <div
    class="px-6 py-4 my-4
      rounded-md text-base flex
      mx-auto w-3/4"
    :class="{
      'bg-red-200' : type === 'error',
      'bg-blue-200' : type === 'info',
    }"
    :style="{
      backgroundColor: type === 'success' ? successBackgroundColor : undefined
    }"
    :role="type === 'error' ? 'alert' : 'status'"
    :aria-live="type === 'error' ? 'assertive' : 'polite'"
    aria-atomic="true"
  >
    <span
      class="w-1/10 mr-2"
      aria-hidden="true"
    >
      <svg
        v-if="type === 'success'"
        viewBox="0 0 24 24"
        class="w-5 h-5"
        :style="{ color: successColor }"
        focusable="false"
      >
        <path
          fill="currentColor"
          d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
        />
      </svg>
      <svg
        v-if="type === 'error'"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-alert-octagon w-5 h-5 bg-none"
        style="color: #D20000;"
        focusable="false"
      >
        <polygon
          fill="none"
          points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
        />
        <line
          x1="12"
          y1="8"
          x2="12"
          y2="12"
        />
        <line
          x1="12"
          y1="16"
          x2="12.01"
          y2="16"
        />
      </svg>
    </span>
    <span
      class="w-9/10 text-left"
      :style="{
        color: type === 'error' ? '#D20000' : type === 'success' ? successColor : undefined,
        fontWeight: type === 'error' ? '700' : undefined
      }"
    > {{ text }} </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { hexToRgba } from '@/utils';
export default defineComponent({
  name: 'Message',
  props: {
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'success'
    }
  },
  computed: {
    ...mapGetters([
      'global'
    ]),
    successColor (): string {
      return this.global.successColor || '#337E33';
    },
    successBackgroundColor (): string {
      return hexToRgba(this.successColor, 0.15);
    }
  }
});
</script>
